import React from "react";
import "./Seguridad.css";
import bioseguridad from "../../../../new_images/Landing/Icons/Icon_bioseguridad.png";
import planificado from "../../../../new_images/Landing/Icons/Icon_conductor_planificado.png";
import asistente from "../../../../new_images/Landing/Icons/Icon_chat.png";

class Opiniones extends React.Component {
  render() {
    return (
      <section style={{display:"flex", flexDirection:"column"}}>
        <div className="po_container col-lg-11">
          <div className="col-lg-9 col-md-11 col-sm-11">
            <p className="po_title">La segurida de todos es importante</p>

            <p className="po_subtitle">
              Cada detalle que forma parte de nuestro servicio se ha creado teniendo en cuenta la seguridad de todos los miembros que forman parte de Tovo. 
            </p>
          </div>
          <div className="row">
            <div id="geolocalizado" className="col-lg-3">
            
              <div>
                <div className="po_header">
                  <img
                    className="po_round_image"
                    src={bioseguridad}
                    alt="avatar"
                    height="10px"
                  />
                  <p className="po_name">Bioseguridad</p>
                </div>
                <div className="po_body">
                  <p className="po_review">Los pasajeros saben que la seguridad de todos es importante, se busca el cumplimiento de la normas de seguridad de mano de cada pasajero.</p>
                </div>
              </div>
            </div>
            <div id="geolocalizado" className="col-lg-3">
            <div>
                <div className="po_header">
                  <img
                    className="po_round_image"
                    src={planificado}
                    alt="avatar"
                    height="10px"
                  />
                  <p className="po_name">Viajes planificados</p>
                </div>
                <div className="po_body">
                  <p className="po_review">Planifica futuros viajes mediante reservas por parte de nuestros pasajeros. </p>
                </div>
              </div>
            </div>

            <div id="asistente" className="col-lg-3">
            <div>
                <div className="po_header">
                  <img
                    className="po_round_image"
                    src={asistente}
                    alt="avatar"
                    height="10px"
                  />
                  <p className="po_name">Asistente Automático</p>
                </div>
                <div className="po_body">
                  <p className="po_review">Resuelve dudas con ayuda de nuestro bot y mejora tu experiencia.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Opiniones;
